module.exports = __webpack_public_path__ + "img/selected3-min.ae6712f9.png";